import React from 'react';
import loadable from '@loadable/component';
import { ErrorBoundary } from 'components/Errors';
import Loader from 'components/Loader';

const ActivateAccount = loadable(() => import(/* webpackChunkName: "ActivateAccount" */ './ActivateAccount'), {
  fallback: <Loader visible />,
});

const AsyncActivateAccount = () => (
  <ErrorBoundary>
    <ActivateAccount />
  </ErrorBoundary>
);

export default AsyncActivateAccount;
